var map = {
	"./amigogaming.webp": 67551,
	"./apparat.webp": 85552,
	"./barbarabang.webp": 3835,
	"./belatragames.webp": 6507,
	"./betgames.webp": 51886,
	"./betgames_rgs.webp": 33501,
	"./bfgames.webp": 92642,
	"./biggaming.webp": 75088,
	"./bigtimegaming.webp": 80476,
	"./blueprint.webp": 43826,
	"./boldplay.webp": 57963,
	"./caleta.webp": 26464,
	"./choicegaming.webp": 34738,
	"./conceptgaming.webp": 90375,
	"./creedroomz.webp": 27628,
	"./ctinteractive.webp": 40177,
	"./dlv.webp": 23507,
	"./dreamgaming.webp": 87453,
	"./egtdigital.webp": 55366,
	"./elbet.webp": 75717,
	"./espressogames.webp": 47947,
	"./eurasiangamingbingo.webp": 97653,
	"./eurasiangamingslots.webp": 93884,
	"./evolution.webp": 5131,
	"./evoplay.webp": 47521,
	"./ezugi.webp": 22547,
	"./fazi.webp": 21052,
	"./fugaso.webp": 7239,
	"./funky_rgs.webp": 77526,
	"./g.games.webp": 84433,
	"./g.gamesbranded.webp": 15818,
	"./gameart.webp": 78171,
	"./gamebeat.webp": 10529,
	"./hacksawgaming.webp": 57342,
	"./hogaming.webp": 75954,
	"./igrosoft.webp": 8083,
	"./irondog_rgs.webp": 81233,
	"./irondogslot.webp": 92745,
	"./irondogtable.webp": 17247,
	"./kagaming.webp": 7257,
	"./kalamba.webp": 59798,
	"./lottoinstantwin.webp": 11430,
	"./mascot.webp": 87308,
	"./microgaminglive.webp": 86525,
	"./microgamingslot.webp": 74908,
	"./mplay.webp": 91802,
	"./netent.webp": 62080,
	"./netgame.webp": 91972,
	"./nexgenspin.webp": 38782,
	"./nolimitcity.webp": 17715,
	"./nucleus.webp": 89167,
	"./onetouch.webp": 86881,
	"./onextwogamingother.webp": 80013,
	"./onextwogamingslot.webp": 39171,
	"./onlyplay.webp": 34168,
	"./orientalgaming.webp": 93448,
	"./pgsoft.webp": 8801,
	"./platipus2.webp": 7494,
	"./playgon_rgs.webp": 90073,
	"./playson.webp": 42776,
	"./playsonpremium.webp": 99800,
	"./playtechlc.webp": 87941,
	"./playtechsl.webp": 99436,
	"./pragmaticplay.webp": 71300,
	"./prettygaming.webp": 75712,
	"./redgenn_rgs.webp": 61342,
	"./redrake.webp": 69974,
	"./redtiger.webp": 35918,
	"./rtgslots.webp": 7266,
	"./rubyplay.webp": 26683,
	"./sagaming.webp": 66406,
	"./sexygaming.webp": 99577,
	"./skywind_rgs.webp": 11259,
	"./skywindlive.webp": 34347,
	"./skywindslot.webp": 52472,
	"./slotmill.webp": 99677,
	"./spadegaming.webp": 28418,
	"./spearhead_rgs.webp": 48876,
	"./spribe.webp": 39157,
	"./spribe_rgs.webp": 72902,
	"./superlottofast.webp": 13455,
	"./superlottoslots.webp": 17184,
	"./superlottotv.webp": 37329,
	"./tomhorn.webp": 81202,
	"./tomhorn_rgs.webp": 50040,
	"./triplecherry.webp": 67455,
	"./tripleprofitsgames.webp": 27814,
	"./vibragaming.webp": 97056,
	"./vibragamingpremium.webp": 63992,
	"./vivogaming.webp": 37216,
	"./voltent.webp": 8472,
	"./winfinity.webp": 87396,
	"./yggdrasil.webp": 71865,
	"./zeusplay.webp": 17772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89964;